// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"231":"896a972057032773","837":"df09b798586a5983","972":"d961b2b2cc0b9a64"}[chunkId] + ".js";
};